<template>
  <div>
    <teleport to="#conversation-summary">
      <n-search-container
        v-if="!isChatRoom"
        :fields="searchFields"
        @search="search"
        @reset="reset"
      >
        <n-search-input
          ref="questSearch"
          v-model="params"
          :fields="searchFields"
        >
          <template #startDate="{ field }">
            <div v-if="params.period != 'other'" />
          </template>
          <template #endDate>
            <div v-if="params.period != 'other'" />
          </template>
        </n-search-input>
        <span
          v-if="params.period === 'other' && isDateRangeOverOneMonth"
          class="text-danger"
        >
          {{ $t('invalid_selected_date_range') }}
        </span>
      </n-search-container>
    </teleport>
    <load-profile />
    <b-card
      v-show="!isChatRoom"
      no-body
      class="mb-0"
    >
      <div class="p-2">
        <div class="d-flex lang-container">
          <!-- <div>
            <label>{{ $t("general.entries") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1 w-20" />
          </div> -->

          <div
            v-if="$can('create', permissionType)"
            class="btn-filter-bot"
          >
            <n-button-loading
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="primary"
              class="btn-submit-bot-filter"
              :loading="loadingDownload"
              @submit="download"
            >
              {{ $t("button.download") }}
            </n-button-loading>
          </div>
        </div>
      </div>
      <div>
        <n-table
          ref="table"
          :fields="fields"
          :items="items"
          :busy="loading"
          :current-page="params.page"
          :per-page="100000"
          :total="total"
          :deletable="false"
          :type="permissionType"
          :route="route"
          :updatable="false"
          @destroy="destroy"
        >
          <template #cell(text)="data">
            <span v-if="data.item.text">
              <p
                v-for="(text, index) in data.item.text"
                :key="index"
              >
                - {{ text }}
              </p>
            </span>
          </template>
          <template #cell(count)="data">
            <b-link>
              {{ data.item.count }}
            </b-link>
          </template>
          <template #cell(pendingCount)="data">
            {{ data.item.statusCount.pending || 0 }}
          </template>
          <template #cell(approvedCount)="data">
            {{ data.item.statusCount.approved || 0 }}
          </template>
          <template #cell(rejectedCount)="data">
            {{ data.item.statusCount.ignored || 0 }}
          </template>
          <template #front-button="data">
            <b-button
              v-b-tooltip.hover
              :title="$t('general.channel')"
              variant="primary"
              pill
              size="sm"
              @click="clickRoom(data.item)"
            >
              <feather-icon
                icon="EyeIcon"
              />
            </b-button>
          </template>
        </n-table>
        <!-- <n-pagination class="mt-2" :total="total" :per-page="$store.state.pagination.perPage" :page="query.page"
          @change="list" /> -->
      </div>
    </b-card>
    <b-card
      v-show="isChatRoom"
      no-body
      class="mb-0"
    >
      <h4
        v-if="selectedData && selectedData.id"
        class="mb-3"
      >
        {{ selectedData.id }}
      </h4>
      <div v-if="selectedData && selectedData.result">
        <n-table
          ref="table"
          :fields="channelTableField"
          :items="selectedData.result ||[]"
          :per-page="1000"
          :current-page="params.page"
          :total="total"
          :deletable="false"
          :type="permissionType"
          :route="route"
          :updatable="false"
        >
          <template #cell(conversation)="data">
            <span
              class="d-block"
              style="width: 400px; white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word;"
              v-html="handleTransform(data.item.topics.conversation)"
            />
          </template>
          <template #cell(fullConversation)="data">
            <span
              class="d-block"
              style="width: 400px; white-space: pre-wrap; word-wrap: break-word; overflow-wrap: break-word;"
              v-html="handleTransform(data.item.fullConversation)"
            />
          </template>
          <template #cell(approvedToRag)="data">
            <div
              v-if="!data.item.isAutoPushToRag && data.item.statusPushToRag === 'pending'"
              class="btn-actions"
            >
              <b-button
                v-if="$can('update', permissionType)"
                v-b-tooltip.hover
                :title="$t('button.approve')"
                variant="success"
                pill
                size="sm"
                @click="showEditModal(data.item)"
              >
                <!-- {{ $t('button.approve') }} -->
                <feather-icon
                  icon="CheckIcon"
                />
              </b-button>
              <b-button
                v-if="$can('update', permissionType)"
                v-b-tooltip.hover
                :title="$t('button.ignore')"
                class="btn"
                variant="danger"
                pill
                size="sm"
                @click="confirmRejectToRag(data.item)"
              >
                <!-- {{ $t('button.ignore') }} -->
                <feather-icon
                  icon="XIcon"
                />
              </b-button>
            </div>
            <div v-if="!data.item.isAutoPushToRag && data.item.statusPushToRag !== 'pending'">
              <b-badge
                v-if="data.item.statusPushToRag === 'ignored'"
                variant="danger"
                pill
              >
                {{ $t('status.ignored') }}
              </b-badge>
              <b-badge
                v-else-if="data.item.statusPushToRag === 'approved'"
                variant="success"
                pill
              >
                {{ $t('status.approved') }}
              </b-badge>
              <!-- <b-badge
                v-else
                variant="warning"
                pill
              >
                {{ $t('status.pending') }}
              </b-badge> -->
            </div>
            <div v-if="data.item.isAutoPushToRag">
              <b-badge
                v-if="data.item.statusPushToRag === 'ignored'"
                variant="danger"
                pill
              >
                {{ $t('status.ignored') }}
              </b-badge>
              <b-badge
                v-else-if="data.item.statusPushToRag === 'approved'"
                variant="success"
                pill
              >
                {{ $t('status.approved') }}
              </b-badge>
              <b-badge
                v-else
                variant="warning"
                pill
              >
                {{ $t('status.pending') }}
              </b-badge>
            </div>
          </template>
          <template #cell(startTime)="data">
            {{ data.item.startTime | formatDate }}
          </template>
          <template #cell(endTime)="data">
            {{ data.item.endTime | formatDate }}
          </template>
          <template #cell(createdAt)="data">
            {{ data.item.createdAt | formatDate }}
          </template>
          <template #cell(topics)="data">
            <div
              style="display: flex; flex-direction: column; gap: 2px;"
            >
              <div>
                <flag
                  iso="us"
                  :squared="false"
                />
                {{ data.item.topics.en }}
              </div>
              <div>
                <flag
                  iso="cn"
                  :squared="false"
                />
                {{ data.item.topics.zh }}
              </div>
            </div>
          </template>

          <!-- <template #cell(chatChannelName)="data">
            <span v-if="data.item.channel">
              {{ data.item.channel.name }}
            </span>
          </template>
          <template #cell(topics)="data">
            <span
              v-for="(topic, index) in data.item.topics"
              :key="index"
              class="d-block mb-1"
            >
              {{ getTopicByCurrentLang(topic) }}
            </span>
          </template>
          <template #cell(conversationDate)="data">
            <span
              v-if="data.item.logDate"
              class="d-block mb-1"
            >
              {{ data.item.logDate | formatDate("LL") }}
            </span>
          </template> -->
          <template #front-button="data">
            <b-button
              v-b-tooltip.hover
              :title="$t('breadcrumb.chat')"
              variant="info"
              pill
              size="sm"
              @click="redirectToChatRoom(data.item)"
            >
              <feather-icon icon="MessageCircleIcon" />
            </b-button>
          </template>
        </n-table>
      </div>
      <b-row>
        <b-col
          cols="12"
          class="text-right"
        >
          <n-button-loading
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            class="mt-1"
            @submit="back"
          >
            {{ $t("button.close") }}
          </n-button-loading>
        </b-col>
      </b-row>
    </b-card>
    <conversation-summary-form-modal
      ref="formModal"
      @submit="updateItemInList"
    />
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BBadge,
  BLink,
  BSpinner,
  BButton,
  BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Repository from '@/repositories/RepositoryFactory'
import NPagination from '@/components/NPagination'
import NTable from '@/components/NTable'
import { avatarText, title } from '@core/utils/filter'
import NInput from '@/components/NInput'
import NButtonLoading from '@/components/NButtonLoading'
import Ripple from 'vue-ripple-directive'
import NSearchInput from '@/components/NSearchInput'
import teleport from '@/helpers/teleport'
import NSearchContainer from '@/components/NSearchContainer.vue'
import { calculateDatesByPeriod } from '@/libs/helper'
import NFormConfirmation from '@/components/NFormConfirmation'
import * as XLSX from 'xlsx'
import NDatePicker from '@/components/NDatePicker'
import store from '@/store'
import channelTableField from './channelTableField'
import tableFields from './tableField'
import formInput from './updateQuestionFrom'
import SearchInputs from './searchInput'
import ConversationSummaryFormModal from './FormModal.vue'

const TopicSummaryRepository = Repository.get('topicSummary')

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BLink,
    BBadge,
    BSpinner,
    NSearchContainer,
    BButton,
    BForm,
    NPagination,
    NTable,
    vSelect,
    NInput,
    NButtonLoading,
    teleport,
    NSearchInput,
    NFormConfirmation,
    NDatePicker,
    ConversationSummaryFormModal,
  },
  directives: {
    Ripple,
  },
  props: {
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      resendLoading: false,
      total: 0,
      perPageOptions: this.$store.state.pagination.perPageOptions,
      params: {
        period: this.$route.query.period || 'thisWeek',
        startDate: this.$route.query.startDate || null,
        endDate: this.$route.query.endDate || null,
        topic: this.$route.query.topic || null,
        status: this.$route.query.status || null,
      },
      query: {
        page: Number(this.$route.query.page) || 1,
        limit: Number(this.$route.query.limit) || 25,
        status: this.$route.query.status || '',
      },
      avatarText,
      data: {
        question: '',
        answer: '',
      },
      options: [],
      listLanguage: [],
      initData: {},
      loadingDownload: false,
      selectedId: null,
      isEdit: false,
      selectedData: {},
      isChatRoom: false,
      formData: {
        conversation: '',
        // fullConversation: '',
      },
      submitting: false,
    }
  },
  computed: {
    perPage: {
      get() {
        return this.$store.state.pagination.perPage
      },
      set(value) {
        this.$store.commit('pagination/SET_PER_PAGE', value)
      },
    },
    isDateRangeOverOneMonth() {
      if (this.params.startDate && this.params.endDate) {
        const start = new Date(this.params.startDate)
        const end = new Date(this.params.endDate)
        const oneMonthLater = new Date(start)
        oneMonthLater.setMonth(oneMonthLater.getMonth() + 1)
        return end >= oneMonthLater
      }
      return false
    },
  },
  watch: {
    perPage() {
      this.list(1)
    },
    'params.period': function (value) {
      this.calculateDate()
    },
    '$i18n.locale': function (value) {
      this.getData()
    },
    tabIndex: {
      immediate: true,
      handler(value) {
        if (value === 0) {
          const query = { ...store.state.app.conversationSummary }
          if (!query.period && !query.startDate && !query.endDate) {
            query.period = 'thisWeek'
          }

          this.query = query
          this.params = query
          this.updateQuerySting()
        }
      },
    },
  },

  mounted() {
    this.getData()
  },
  methods: {
    confirmRejectToRag(item) {
      this.$bvModal.msgBoxConfirm(
        this.$t('confirm_ignore_to_rag'),
        {
          title: this.$t('alert.confirmContinueOperation'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: this.$t('button.ignore'),
          cancelTitle: this.$t('button.cancel'),
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        },
      )
        .then(value => {
          if (value) {
            this.rejectToRag(item)
          }
        })
    },
    async rejectToRag(item) {
      try {
        await TopicSummaryRepository.updateConversationSummary(item.id, {
          topics: item.topics,
          // fullConversation: item.fullConversation,
          statusPushToRag: 'ignored',
        })

        // Update the item in the list
        const index = this.selectedData.result.findIndex(i => i.id === item.id)
        if (index !== -1) {
          this.$set(this.selectedData.result, index, {
            ...this.selectedData.result[index],
            statusPushToRag: 'ignored',
          })
          this.$set(this.selectedData, 'statusCount', {
            ...this.selectedData.statusCount,
            pending: this.selectedData.statusCount.pending ? this.selectedData.statusCount.pending - 1 : 0,
            ignored: this.selectedData.statusCount.ignored ? this.selectedData.statusCount.ignored + 1 : 1,
          })
        }
      } catch (error) {
        console.error('Approve failed:', error)
        this.$toast.error(this.$t('message.update_failed'))
      }
    },
    async onSubmit() {
      const isValid = await this.$refs.formValidation.validate()
      if (!isValid || this.submitting) return

      this.submitting = true
      try {
        await TopicSummaryRepository.updateConversationSummary({
          topics: [{
            conversation: this.formData.conversation,
          }],
          statusPushToRag: 'approved',
          // fullConversation: this.formData.fullConversation,
        })
        this.$toast.success(this.$t('message.update_success'))
        this.hideEditModal()
        this.getData()
      } catch (error) {
        console.error('Update failed:', error)
        this.$toast.error(this.$t('message.update_failed'))
      } finally {
        this.submitting = false
      }
    },
    hideEditModal() {
      this.$refs.editModal.hide()
    },
    updateItemInList(updatedItem) {
      // Update item in selectedData.result array
      const index = this.selectedData.result.findIndex(item => item.id === updatedItem.id)
      if (index !== -1) {
        // Update the item while maintaining reactivity
        this.$set(this.selectedData.result, index, {
          ...this.selectedData.result[index],
          topics: {
            ...this.selectedData.result[index].topics,
            conversation: updatedItem.topics.conversation,
          },
          statusPushToRag: 'approved',
          // fullConversation: updatedItem.fullConversation,
        })
        this.$set(this.selectedData, 'statusCount', {
          ...this.selectedData.statusCount,
          pending: this.selectedData.statusCount.pending ? this.selectedData.statusCount.pending - 1 : 0,
          approved: this.selectedData.statusCount.approved ? this.selectedData.statusCount.approved + 1 : 1,
        })
      }
    },
    showEditModal(item) {
      this.$refs.formModal.show(item)
    },
    handleTransform(text) {
      if (!text) return 'N/A'
      const conversation = text
        .split('\n')
        .map(line => line)
        .join('\n')
      return conversation
    },
    updateQuerySting() {
      this.$router.replace({ query: this.query })
      this.$nextTick(() => {
        if (this.query.cache != 'no') {
          store.commit('app/UPDATE_CONVERSATION_SUMMARY', { ...this.query, tabIndex: 0 })
        }
      })
    },
    list(page = 1) {
      this.query.page = page
      this.query.limit = this.perPage
      this.updateQuerySting()
      this.getData()
    },
    onChange(value) {
      if (value?.languageId) {
        this.query.lang = value?.languageId
        this.getData()
      }
    },
    getData() {
      if (this.isDateRangeOverOneMonth) {
        return
      }
      this.loading = true
      if (!this.params.startDate || !this.params.endDate) {
        this.calculateDate()
      } else {
        this.formatIsoTimeString()
      }

      this.query.status = this.params.status
      this.updateQuerySting()

      TopicSummaryRepository.conversationSummary({
        ...this.query,
        status: this.params.status ? this.params.status.trim() : '',
        topic: this.params.topic ? this.params.topic.trim() : '',
        lang: this.$i18n.locale.split('-')[0] === 'zh' ? 'zh' : 'en',
      })
        .then(response => {
          const { list } = response.data.data

          this.items = [...list]
          this.total = response.data.data.total
          if (this.selectedData.result) {
            this.selectedData = this.items.filter(item => item.result[0].channel.id === this.selectedData.result[0].channel.id)[0]
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    destroy(id) {
      TopicSummaryRepository.destroyTopicSummary(id)
        .catch(err => {
          console.log('err', err)
        })
        .finally(() => {
          this.getData()
        })
    },
    calculateDate() {
      let dates
      if (this.params.period == 'other') {
        dates = calculateDatesByPeriod('thisWeek')
      } else {
        dates = calculateDatesByPeriod(this.params.period)
      }
      if (dates.length) {
        // Set start date to 12:00:00 AM
        const startDate = new Date(dates[0])
        startDate.setHours(0, 0, 0, 0)

        // Set end date to 11:59:59 PM
        const endDate = new Date(dates[1])
        endDate.setHours(23, 59, 59, 999)

        this.params.startDate = startDate.toISOString()
        this.params.endDate = endDate.toISOString()
        this.query.startDate = startDate.toISOString()
        this.query.endDate = endDate.toISOString()
      }
    },
    formatIsoTimeString() {
      const startDate = new Date(this.params.startDate)
      startDate.setHours(0, 0, 0, 0)
      // Set end date to 11:59:59 PM
      const endDate = new Date(this.params.endDate)
      endDate.setHours(23, 59, 59, 999)
      this.query.startDate = startDate.toISOString()
      this.query.endDate = endDate.toISOString()
    },
    search() {
      if (this.isDateRangeOverOneMonth) {
        return
      }
      this.list()
    },
    reset() {
      this.$refs.questSearch.reset()
      this.params.period = 'thisWeek'
      this.calculateDate()
      this.updateQuerySting()
      this.getData()
    },
    validateForm() {
      this.$refs.editForm.validate().then(async success => {
        if (success) {
          await this.submit()
        }
      })
    },
    clickRoom(data) {
      this.selectedData = data
      this.isChatRoom = true
    },
    back() {
      this.isChatRoom = false
    },
    download() {
      this.loadingDownload = true
      if (!this.params.startDate || !this.params.endDate) {
        this.calculateDate()
      } else {
        this.formatIsoTimeString()
      }
      TopicSummaryRepository.downloadConversationSummary({
        startDate: this.params.startDate,
        endDate: this.params.endDate,
        status: this.params.status ? this.params.status.trim() : '',
        lang: this.$i18n.locale.split('-')[0] === 'zh' ? 'zh' : 'en',
      })
        .then(async response => {
          let arrayBuffer
          // Determine the array buffer from the response
          if (response.data instanceof ArrayBuffer) {
            arrayBuffer = response.data
          } else if (response.arrayBuffer) {
            arrayBuffer = await response.arrayBuffer()
          } else if (response instanceof ArrayBuffer) {
            arrayBuffer = response
          } else {
            arrayBuffer = new TextEncoder().encode(response.data || response).buffer
          }

          // Convert workbook to CSV
          const workbook = XLSX.read(arrayBuffer, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]

          // Convert to CSV
          const csvData = XLSX.utils.sheet_to_csv(worksheet, {
            // Optional: you can pass encoding options here if needed
            // FS: field separator
            // RS: row separator
          })

          const utf8WithBom = `\uFEFF${response.data}` // Add BOM for UTF-8
          const blob = new Blob([utf8WithBom], { type: 'text/csv;charset=utf-8;' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url

          const fileName = `conversation_summary_report_${this.params.startDate
            .split('T')[0]
            .replace(/[^a-z0-9]/gi, '_')}-${this.params.endDate
            .split('T')[0]
            .replace(/[^a-z0-9]/gi, '_')}.csv`

          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          // Clean up
          URL.revokeObjectURL(url)
        })
        .catch(error => {
          console.error('Download failed:', error)
        })
        .finally(() => {
          this.loadingDownload = false
        })
    },
    getTopicByCurrentLang(topic) {
      const currentLang = this.$i18n.locale.split('-')[0]
      return topic[currentLang] ? topic[currentLang] : topic.en
    },
    redirectToChatRoom(data) {
      const url = this.$router.resolve({
        name: 'chat',
        query: {
          from: 'topic-summary',
          channelId: data.chatChannelId,
        },
      })
      window.open(url.href, '_blank')
    },
  },
  setup() {
    const fields = tableFields
    // const channelTableField1 = channelTableFields
    const searchFields = SearchInputs
    const updateForm = formInput
    const permissionType = 'summary-conversation'
    const route = 'topic'

    return {
      fields,
      searchFields,
      permissionType,
      route,
      updateForm,
      channelTableField,
    }
  },
}
</script>

<style lang="scss">
.lang-input span label {
  display: none !important;
}

.lang-container {
  width: 100%;
  gap: 10px;
}

.btn-filter-bot {
  display: flex;
  flex: 1;
  justify-content: end;
}

.btn-submit-bot-filter {
  height: fit-content;
}

.w-20 {
  width: 100px;
}

.lang-container .v-select.vs--single.vs--searchable {
  width: 150px;
}

.displays {
  display: flex;
  justify-items: center;
}
.btnRetrain {
  border: none;
  background: rgb(6, 172, 67);
  color: rgb(255, 255, 255);
  margin-left: 7px;
  border-radius: 5px;
  cursor: pointer;
}

.btn-actions {
  display: flex;
  gap: 5px
}
@import "@core/scss/vue/libs/vue-select.scss";
</style>
